// Élaument cart actions.
//
// A button carries data-cro-ops, a JSON array of operations run in order:
//   {"op":"add","id":<variantId>,"qty":1,"plan":<sellingPlanId>}
//   {"op":"change","key":"<lineKey>","qty":1,"plan":<sellingPlanId>}   (qty 0 removes)
//
// Adds always run before removals so the cart is never momentarily empty.
// The last call asks Shopify to re-render the cart sections, and the drawer is
// refreshed in place rather than navigating away. On the cart page the page is
// reloaded instead, because its summary lives outside the cart items component.
//
// First party only: no requests beyond Shopify's own cart endpoints.

function elaumentSectionIds() {
  const ids = new Set();
  document.querySelectorAll('cart-items-component').forEach((el) => {
    if (el.dataset.sectionId) ids.add(el.dataset.sectionId);
  });
  return Array.from(ids);
}

async function elaumentRunOps(ops, sectionIds) {
  let last = null;

  for (let i = 0; i < ops.length; i += 1) {
    const op = ops[i];
    const isLast = i === ops.length - 1;
    let url;
    let body;

    if (op.op === 'add') {
      const item = { id: Number(op.id), quantity: op.qty == null ? 1 : Number(op.qty) };
      if (op.plan) item.selling_plan = Number(op.plan);
      url = '/cart/add.js';
      body = { items: [item] };
    } else {
      url = '/cart/change.js';
      body = { id: op.key, quantity: op.qty == null ? 1 : Number(op.qty) };
      if (op.plan) body.selling_plan = Number(op.plan);
    }

    if (isLast && sectionIds.length) {
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname;
    }

    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });

    if (!response.ok) throw new Error('Cart request failed with status ' + response.status);
    last = await response.json();
    if (last && last.status && last.status >= 400) throw new Error(last.description || last.message || 'Cart error');
  }

  return last;
}

function elaumentRefresh(payload) {
  if (!payload || !payload.sections) {
    window.location.reload();
    return;
  }

  const parser = new DOMParser();
  let replaced = 0;

  document.querySelectorAll('cart-items-component').forEach((component) => {
    const html = payload.sections[component.dataset.sectionId];
    if (!html) return;
    const parsed = parser.parseFromString(html, 'text/html');
    const fresh =
      parsed.querySelector('cart-items-component[data-section-id="' + component.dataset.sectionId + '"]') ||
      parsed.querySelector('cart-items-component');
    if (!fresh) return;
    component.innerHTML = fresh.innerHTML;
    replaced += 1;

    const freshCount = parsed.querySelector('.cart-bubble__text-count');
    const count = document.querySelector('.cart-bubble__text-count');
    if (freshCount && count) count.textContent = freshCount.textContent;
  });

  if (!replaced) window.location.reload();
}

function elaumentCartAction(event) {
  const btn = event.target.closest('[data-cro-cart-add]');
  if (!btn) return;
  event.preventDefault();
  if (btn.dataset.busy === '1') return;

  let ops;
  try {
    ops = JSON.parse(btn.getAttribute('data-cro-ops') || '[]');
  } catch (err) {
    ops = [];
  }

  if (!ops.length) {
    const addId = btn.getAttribute('data-add-id');
    const removeKey = btn.getAttribute('data-remove-key');
    if (addId) ops.push({ op: 'add', id: addId, qty: 1 });
    if (removeKey) ops.push({ op: 'change', key: removeKey, qty: 0 });
  }

  if (!ops.length) return;

  btn.dataset.busy = '1';
  btn.setAttribute('disabled', '');

  const onCartPage = window.location.pathname.indexOf('/cart') === 0;
  const sectionIds = onCartPage ? [] : elaumentSectionIds();

  elaumentRunOps(ops, sectionIds)
    .then((payload) => {
      if (onCartPage) {
        window.location.reload();
        return;
      }
      elaumentRefresh(payload);
    })
    .catch((err) => {
      btn.removeAttribute('disabled');
      delete btn.dataset.busy;
      console.error('Élaument cart action failed', err);
    });
}

if (!window.__elaumentCartActionBound) {
  window.__elaumentCartActionBound = true;
  document.addEventListener('click', elaumentCartAction);
}
